module.exports = __webpack_public_path__ + "static/media/KkGuideServiceRecipients.27ca60bb.pdf";